import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=66607906&"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports